import React, { FC } from 'react';

import { useIntl } from 'react-intl';
import styled from 'styled-components';

import NavLink from 'components/app-header/nav-link';
import SkipToContent from 'components/skip-content';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { CustomEventNames } from 'state/mParticle';
import { routes } from 'utils/routing';

import { ILeftNav } from '../types';

import { messages } from './messages';

const StyledExternalLink = styled.a`
  text-decoration: none;
  color: currentColor;
  font-family: ${Styles.fontFamily.base};
  font-size: 1.125rem;
  margin-left: 1.3rem;

  &.active,
  &:hover {
    text-decoration: none;
  }

  &:first-of-type {
    margin-left: 0;
  }

  &:active,
  &.active {
    color: ${Styles.color.tertiary};
  }

  &.active,
  &:hover {
    color: ${Styles.color.tertiary};
  }
`;

export const StaticLeftNav: FC<ILeftNav> = ({ orderHref, curriedHandleClick }) => {
  const { formatMessage } = useIntl();
  const enableCatering = useFlag(LaunchDarklyFlag.ENABLE_CATERING);

  return (
    <>
      <SkipToContent />
      <NavLink
        data-testid="order-desktop"
        to={orderHref}
        onClick={curriedHandleClick(CustomEventNames.BUTTON_CLICK_ORDER)}
      >
        {formatMessage(messages.order)}
      </NavLink>
      {enableCatering ? (
        <NavLink
          to={routes.catering}
          onClick={curriedHandleClick(CustomEventNames.BUTTON_CLICK_CATERING)}
        >
          {formatMessage(messages.catering)}
        </NavLink>
      ) : (
        <StyledExternalLink
          href="https://catering.timhortons.com"
          onClick={curriedHandleClick(CustomEventNames.BUTTON_CLICK_CATERING)}
        >
          {formatMessage(messages.catering)}
        </StyledExternalLink>
      )}
    </>
  );
};
